<div id="city-field" class="city-input" [hidden]="isManualInput">
  <mat-form-field class="w-100 pb-0 mb-0" (keyup)="checkLatin($event)" [floatLabel]="floatLabel">
    <mat-label class="subtitle_1 text-black">{{labelContent}}</mat-label>
    <input #cityAddress [formControl]="cityControl" [matAutocomplete]="auto" class="text_3" matInput type="text"
           (input)="onValueChange($event.target['value'])">

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onValueChange($event.option.value)">
      <mat-option *ngFor="let city of filteredCity | async" [value]="city" (click)="onClick($event)">
        {{city.name}}
      </mat-option>
    </mat-autocomplete>

    <mat-error *ngIf="cityControl.hasError('required')" class="minitext_2">
      {{ "COMMON.IS_REQUIRED" | translate }}
    </mat-error>
  </mat-form-field>
</div>




<div class="city-input" *ngIf="isManualInput">
  <mat-form-field class="w-100 pb-0 mb-0" (keyup)="checkLatin($event)" [floatLabel]="floatLabel">
    <mat-label class="subtitle_1 text-black">{{labelContent}}</mat-label>
    <input  [formControl]="cityControl" class="text_3" matInput type="text"
           (input)="onValueChange($event.target['value'])">

    <mat-error *ngIf="cityControl.hasError('required')" class="minitext_2">
      {{ "COMMON.IS_REQUIRED" | translate }}
    </mat-error>
  </mat-form-field>

  <p class="lightGray2 minitext_2">{{ 'COMMON.INVALID_ADDRESS_NOT_RESPONSIBLE' | translate }}</p>

</div>

<button type="button" id="autocomplete_address_not_found" (click)="goManual(!isManualInput)" *ngIf="showManualInput && showManualButton"
        class="btn p-0 text_5 border-0 txt-dark-blue mb-0 manualButton">
  {{ (isManualInput ? 'COMMON.ADDRESS_GO_AUTOCOMPLETE' : 'COMMON.ADDRESS_GO_MANUAL') | translate}}
</button>
